const isDesktopMq = window.matchMedia("(min-width: 768px)");

class GallerySingleImagesEach {
  el: HTMLElement;
  dialog: HTMLDialogElement | null;
  closeButton: HTMLButtonElement | null;
  constructor(el: HTMLElement) {
    this.el = el;
    this.dialog = document.querySelector<HTMLDialogElement>(
      `[data-dialog-single-image-each][data-id="${this.el.dataset.id}"]`
    );
    this.closeButton =
      this.dialog?.querySelector<HTMLButtonElement>("[data-close]") ?? null;

    this.init();
  }

  init() {
    this.initResize();
    this.initDialog();
  }

  initDialog() {
    const toggle = this.el.querySelector<HTMLButtonElement>("[data-toggle]");
    toggle?.addEventListener("click", () => {
      if (!this.dialog) return;
      this.dialog.showModal();
      document.querySelector("html")?.classList.add("dialog-open");
    });

    this.closeButton?.addEventListener("click", () => {
      if (!this.dialog) return;
      this.dialog.close();
    });

    this.dialog?.addEventListener("close", () => {
      document.querySelector("html")?.classList.remove("dialog-open");
    });
  }

  initResize() {
    window.addEventListener("resize", () => {
      if (!isDesktopMq.matches) {
        this.dialog?.close();
      }
    });
  }
}

document
  .querySelectorAll<HTMLElement>("[data-gallery-single-each]")
  .forEach((el) => {
    new GallerySingleImagesEach(el);
  });
